/* eslint-disable react/prop-types */
import { CasinoProviderDATA } from "../../../constants/Casino/CasinoProviderData";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLoginNew } from "../../../store/LoginNew/loginNew.slice";
import { openSlotCasinoPopUp } from "../../../store/slotCasinoPopUp/slotCasinoPopUp.slice";
import { USER_DATA } from "../../../config/app.config";
import { toastr } from "react-redux-toastr";

const HomeCasinoProviderList = ({ seeAll }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  let userDetail = localStorage.getItem(USER_DATA);
  let userData = JSON.parse(userDetail);

  const handleNavigate = (item) => {
    if (auth) {
      if (userData?.is_demo) {
        toastr.error("", "Please login from your read ID.");
        return;
      }

      navigate(`/casino-lobby/provider/${item?.name}/${item?.provider}`);
      dispatch(openSlotCasinoPopUp(true));
    } else {
      dispatch(setLoginNew(true));
    }
  };

  return (
    <div
      className={`min-w-full grid ${
        seeAll
          ? `xxs:grid-cols-3 sm:grid-cols-4 md:grid-cols-${location?.pathname === "/" ? "6" : "8"} lg:grid-cols-${location?.pathname === "/" ? "6" : "8"} xlg:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-5`
          : location?.pathname === "/"
          ? "grid-rows-3 grid-flow-col"
          : "grid-rows-1 grid-flow-col"
      }  gap-2`}
    >
      {CasinoProviderDATA.map((item, index) => {
        return (
          <button
            key={`${item?.provider}_${index}`}
            className={` leading-normal relative overflow-hidden   transition-all bg-bg_CasinoProvider ease-in-out duration-100 flex xxs:min-w-[80px] xs:min-w-[100px] sm:min-w-[150px] min-h-[45px] md:min-h-[60px] px-5 py-2 flex-col items-center justify-center gap-1 rounded-[12px] border-2 rounded-2  text-text_Quaternary whitespace-nowrap uppercase font-lato font-[700] text-xs hover:scale-105 shadow-homeCasinoCardGamesShadow   cursor-pointer ${
              location?.pathname === "/" && seeAll && "md:min-w-[90px]"
            }`}
            type="button"
            title={item?.name}
            onClick={() => {
              handleNavigate(item);
            }}
          >
            <div
              title="InPlayAndPopulars"
              id="banners"
              className="py-2 flex items-center flex-col justify-center w-[80px] h-[50px]  "
            >
              <img
                src={item?.image}
                width="80"
                height="40"
                className=" rounded rounded-8 "
                alt={item?.name}
                loading="lazy"
                title={item?.name}
              />
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default HomeCasinoProviderList;
